<template>
  <div id="recomd">
    <ContenctLensTable
      title=""
      :inputList="inputList"
      :outputList="outputList"
      :isOrthokeratology="true"
      calFunc="okLensRecommend"
    />
  </div>
</template>

<script>
import ContenctLensTable from "./ContenctLensTable";
import { paramNormal } from "../../shared/filters";
import { INVALID_1000 } from "../../shared/consts";
import CalElev from "../js/CalElev";
import ColorMapHelper from "../js/ColorMapHelper";
import { MAPSTYLES, hasKey, getKey } from "../shared";
import { calcElevDiff } from "../js/calc4mmElevDiff";

import { getPupilCorneadiaKey } from "../../shared/utils";

export default {
  name: "RGP-RecomOK",
  components: {
    ContenctLensTable
  },
  props: {
    mapValues: {
      type: Object,
      default() {
        return {};
      }
    },
    record: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentEye: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      inputList: [
        { label: this.$t("langcfg.txtSphS"), val: "" },
        { label: this.$t("langcfg.txtCylC"), val: "" },
        {
          label: this.$t("langcfg.txtFlatkD"),
          val: paramNormal(this.mapValues.params["K1"].value, { fixed: 2, rpText: "" })
        },
        {
          label: this.$t("langcfg.txtSteepkD"),
          val: paramNormal(this.mapValues.params["K2"].value, { fixed: 2, rpText: "" })
        },
        {
          label: this.$t("langcfg.txtEccVal"),
          val: paramNormal(this.mapValues.params["EccPEQ"].value, { fixed: 2, rpText: "" })
        },
        {
          label: this.$t("langcfg.txtW2W"),
          val: paramNormal(this.getW2w(), { fixed: 2, rpText: "" })
        },
        { label: this.$t("langcfg.txtDiffHightR4"), val: "" }
      ],
      outputList: [
        { label: this.$t("langcfg.txtDiopter"), val: "" },
        { label: this.$t("langcfg.txtPositioningArcD"), val: "" },
        { label: this.$t("langcfg.txtDiaUnit"), val: "" },
        { label: "Toric", val: "" },
        { label: this.$t("langcfg.txtSuggestedPositioningArc"), val: "" }
      ]
    };
  },
  mounted() {
    this.loadElevDiff4Value();
  },
  methods: {
    calxy(dia, theta, add180 = false) {
      return {
        x: dia * Math.cos(((theta + (add180 ? 180 : 0)) * Math.PI) / 180),
        y: dia * Math.sin(((theta + (add180 ? 180 : 0)) * Math.PI) / 180)
      };
    },
    loadElevDiff4Value() {
      let params = this.mapValues.params;
      let diffVal = calcElevDiff(
        this.$store.state.topography.casePath,
        params.AxisFlat.value,
        params.AxisSteep.value
      ).val;

      if (this.mapValues.params.elevDiff4mm.value !== INVALID_1000) {
        this.inputList[6].val = this.mapValues.params.elevDiff4mm.value._toFixed(0);
      }
      if (diffVal !== INVALID_1000) {
        this.inputList[6].val = diffVal._toFixed(0);
      }
    },
    getElevMapValue(p1, p2, p3, p4) {
      let elevData = this.calElevParams();
      if (!elevData) {
        return INVALID_1000;
      }
      let casepath = this.$store.state.topography.casePath;
      let ptr = ColorMapHelper.initColorMap();
      if (!ptr) {
        return INVALID_1000;
      }
      if (
        ColorMapHelper.updateMapProp(ptr, MAPSTYLES.ElevationF, casepath) &&
        ColorMapHelper.UpdateMapData(ptr, elevData)
      ) {
        let arr = [p1, p2, p3, p4];
        let result = true;
        arr.forEach((item) => {
          let obj = ColorMapHelper.getPixelIndexAndValue(ptr, item.x, item.y);
          if (obj.result === 0) {
            item.value = obj.value;
          } else {
            result = false;
            item.value = INVALID_1000;
          }
        });
        if (result) {
          ColorMapHelper.freeColorMap(ptr);
          return Math.abs((arr[0].value + arr[1].value - arr[2].value - arr[3].value) / 2);
        }
      }
      ColorMapHelper.freeColorMap(ptr);
      return INVALID_1000;
    },
    calElevParams() {
      let casepath = this.$store.state.topography.casePath;
      let elevParams = CalElev.getDefaultParams();
      let data = null;
      if (CalElev.cal(elevParams, casepath)) {
        data = elevParams.data;
      }
      CalElev.free(elevParams);
      return data;
    },
    getW2w() {
      let w2w = INVALID_1000;
      // let key = `content.data${this.currentEye}.pupilcorneadia.corneadia.edge.r`;
      let key = getPupilCorneadiaKey(this.record, this.currentEye);

      if (hasKey(this.record, key)) {
        let r = getKey(this.record, key);
        if (r !== INVALID_1000) {
          w2w = r * window.magecoe.pupilcornea * 2;
        }
      }
      return w2w;
    }
  }
};
</script>

<style lang="less">
#recomd {
  .el-input__inner {
    background-color: #44444c;
    border: @normal-border; //1px solid #909399;
    color: white;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    background-color: transparent;
    color: white;
    width: 420px;
    border: none; //@normal-border; //1px solid #909399;
    border-right: 0;
    font-size: 25px;
    white-space: normal;
  }
  .el-button {
    background: transparent;
    color: white;
    font-size: 25px;
  }
  .el-button:focus {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP-RecomOK.vue